// extracted by mini-css-extract-plugin
export default {"navBarDesign":"header_navBarDesign__kfr49","navBarDesignLogo":"header_navBarDesignLogo__AqQMW","navBarDesignLink":"header_navBarDesignLink__sp0-Z"};